'use client';

/**
 * @file     useResolvedContent.ts
 * @purpose  React hook that resolves a content schema via resolveContent() and memoizes the result, re-running when the active language changes.
 */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { resolveContent } from './resolveContent';
import type { ResolvedContent } from './types';

export const useResolvedContent = <TSchema,>(schema: TSchema): ResolvedContent<TSchema> => {
  const { t, i18n } = useTranslation();

  return useMemo(
    () => resolveContent(t, schema),
    [i18n.resolvedLanguage, schema, t],
  ) as ResolvedContent<TSchema>;
};
